import {sanitizeOriginHostname} from "../utilities/Helper";

export const COMPANY_NAME = "BINUS University";
export const PROJECT_NAME = "Beelajar";
export const PROJECT_DESC = "Beelajar";
export const BRAND_LOGO = "__beelajar_brand_logo__";
export const LANDING_PAGE_CONFIG = "__beelajar_landing_page_config__";

export const APP_BASE_URL = sanitizeOriginHostname(window.location.origin) + "/auth/msal"; // https://developer.mozilla.org/en-US/docs/Web/API/Location/origin
// export const APP_BASE_URL = window.location.origin; // https://developer.mozilla.org/en-US/docs/Web/API/Location/origin